import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <div className="coming-soon-container">
        <div className="coming-soon-text">
          <h1 className="coming">Poroshtica</h1>
          <h1 className="soon">Web</h1>
        </div>
        <div className="logo-symbols">
          <Link to="/df" className="symbol clickable">Ɗf</Link>
          <div className="symbol">LA</div>
          <div className="symbol">E?</div>
        </div>
      </div>
    </div>
  );
};

export default Home;